import React from "react"
import PageBanner from "../../layouts/PageBanner"
import bg from "../../assets/images/banner/bnr4.jpg"
import shape2 from "../../assets/images/pattern/shape2.png"
import shape3 from "../../assets/images/pattern/shape3.png"
import shape5 from "../../assets/images/pattern/shape5.png"
import shape1 from "../../assets/images/pattern/shape1.png"
import shape6 from "../../assets/images/pattern/shape6.png"

const Policy = () => {
  return (
    <div className="page-content bg-white">
      <PageBanner maintitle="Home" pagetitle="Privacy Policy" />
      <section className="content-inner-2 bg-light section-pattren1">
        <div className="container text-dark">
          {/* <h1 className="h1 fw-bold text-primary mb-4">
            Child Safety Standards Policy
          </h1> */}
          <p>Effective Date:<strong> April 15th, 2023</strong> </p>
          <p>Last Updated:<strong> April 12th, 2025</strong> </p>

          <h5 className="mt-4 fw-bold">1. Purpose</h5>
          <p>
            San Antonio Tamil Sangam (SATS) is deeply committed to creating a safe,
            respectful, and culturally supportive environment for children and
            youth who use our digital platforms. This policy outlines the
            procedures and standards we follow to protect the safety, privacy,
            and well-being of children participating in our online and offline
            activities.
          </p>

          <h5 className="mt-4 fw-bold">2. Scope</h5>
          <p>This policy applies to:</p>
          <ul>
            <li>All users under the age of 18 on the SATS App</li>
            <li>Parents/guardians of child users</li>
            <li>
              All SATS executive officers, executive committee members, board
              of trustees, volunteers, resource persons, event organizers, and
              content moderators
            </li>
            <li>Any community member contributing or interacting on the SATS App</li>
          </ul>

          <h5 className="mt-4 fw-bold">3. Parental Consent and Supervision</h5>
          <ul>
            <li>
              Children under 13 are not permitted to register on the app without
              verifiable parental or guardian consent.
            </li>
            <li>
              A parent/guardian must approve the child’s participation in any
              digital events or forums hosted through the app.
            </li>
            <li>
              Parents may request access to their child’s data or activity log
              at any time.
            </li>
          </ul>

          <h5 className="mt-4 fw-bold">4. Data Protection and Privacy</h5>
          <ul>
            <li>
              SATS does not collect or display children’s personal information
              beyond what is necessary for event participation or user profile
              creation.
            </li>
            <li>
              Children's data is stored securely and is never sold, shared, or
              published without explicit parental consent.
            </li>
            <li>
              Photos or videos of minors will not be shared publicly unless
              authorized by a parent/guardian via a signed media release form.
            </li>
          </ul>

          <h5 className="mt-4 fw-bold">5. Safe Content and Communication</h5>
          <ul>
            <li>
              All content shared on the SATS App must be age-appropriate,
              inclusive, and respectful of Tamil cultural values.
            </li>
            <li>
              Moderators will review all event postings, comments, and media to
              ensure compliance.
            </li>
            <li>
              Private one-on-one messaging between adults and minors is
              prohibited unless the adult is a designated SATS moderator or
              instructor with approved background screening.
            </li>
          </ul>

          <h5 className="mt-4 fw-bold">6. Code of Conduct for Adults and Volunteers</h5>
          <p>
            All adults interacting with children via SATS events or the app must:
          </p>
          <ul>
            {/* <li>Complete a background check</li> */}
            <li>Sign a Child Protection Code of Conduct</li>
            <li>
              Complete child safety awareness training, if required
            </li>
            <li>
              Inappropriate behavior, including harassment, favoritism, or
              inappropriate communication with minors, will result in
              disciplinary action.
            </li>
          </ul>

          <h5 className="mt-4 fw-bold">7. Online Events and Safety</h5>
          <ul>
            <li>
              All virtual events involving children (volunteering programs,
              cultural training, competitions) will be monitored by at least two
              adults.
            </li>
            <li>
              Sessions may be recorded for safety purposes, with prior
              notification to parents.
            </li>
          </ul>

          <h5 className="mt-4 fw-bold">8. Reporting Concerns</h5>
          <p>
            Concerns regarding child safety, bullying, inappropriate content, or
            suspicious behavior can be reported through:
          </p>
          <ul>
            <li>The in-app reporting feature</li>
            <li>Direct email: <a href="mailto:sats@satamilsangam.org">sats@satamilsangam.org</a></li>
          </ul>
          <p>
            Reports will be reviewed within 48 hours by SATS’s Child Safety Officer
            or Executive Committee. Urgent concerns may be escalated to
            appropriate legal or child protection authorities.
          </p>

          <h5 className="mt-4 fw-bold">9. Education and Awareness</h5>
          <ul>
            <li>
              SATS will provide families with resources on digital safety and
              positive online behavior.
            </li>
            <li>
              Periodic workshops on child safety (both in-person and online)
              will be organized for parents and volunteers.
            </li>
          </ul>

          <h5 className="mt-4 fw-bold">10. Enforcement</h5>
          <p>Violations of this policy may lead to:</p>
          <ul>
            <li>Content removal</li>
            <li>Temporary or permanent suspension of user accounts</li>
            <li>Disqualification from SATS events</li>
            <li>Legal escalation, if warranted</li>
          </ul>

          <h5 className="mt-4 fw-bold">Contact Us</h5>
          <p>
            For questions or concerns about this policy, please contact:<br />
            <a href="mailto:sats@satamilsangam.org">sats@satamilsangam.org</a><br />
            <a href="https://www.satamilsangam.org" target="_blank" rel="noreferrer">www.satamilsangam.org</a>
          </p>
        </div>

        {/* Decorative shapes */}
        <img src={shape2} className="shape-6 move-2" alt="shape" />
        <img src={shape3} className="shape-5 move-1" alt="shape" />
        <img src={shape5} className="shape-1 rotating" alt="shape" />
        <img src={shape1} className="shape-3 move-1" alt="shape" />
        <img src={shape6} className="shape-4 rotating" alt="shape" />
        <img src={shape6} className="shape-2 rotating" alt="shape" />
      </section>
    </div>
  )
}

export default Policy
